const zh = {
  AuthTitle: {
    Greetings: "欢迎来到",
  },
  Auth: {
    EnterEmail: "输入邮箱",
    EnterPassword: "输入密码",
    AgreeWith: "我同意",
    ProcessingPersonalData: "处理个人数据",
    UserAgreement: "用户协议",
    EmailRequiredError: "需要填写邮箱",
    EmailWrongFormatError: "邮箱格式不正确！",
    PasswordRequiredError: "错误：需要填写密码",
    ForgotPassword: "忘记密码",
  },
  Login: {
    Title: "登录",
    Subtitle: "请填写以下字段以登录您的账户。",
    Login: "登录",
    Register: "注册",
    LoginError: "输入的用户名或密码不正确",
    BuyTeacherLessons: "购买教师课程",
  },
  Register: {
    Title: "注册",
    Subtitle: "请填写以下字段以注册您的账户。",
    Register: "注册",
    Login: "登录",
    EnterLastName: "输入姓氏",
    EnterFirstName: "输入名字",
    EnterEmail: "输入邮箱",
    EnterGender: "性别",
    EnterBirthday: "出生日期",
    EnterProfileCountryId: "国籍",
    EnterProfileCityId: "到达城市",
    EnterProfileDegreeId: "学历",
    EnterPassword: "输入密码",
    RepeatPassword: "重复密码",
    LastNameRequiredError: "需要填写姓氏",
    LastNameMinLengthError: "至少 2 个字符",
    FirstNameRequiredError: "需要填写名字",
    FirstNameMinLengthError: "至少 2 个字符",
    PhoneRequiredError: "需要填写电话号码",
    PhoneInvalidError: "电话号码格式不正确",
    GenderRequiredError: "需要填写性别",
    BirthdayRequiredError: "需要填写出生日期",
    ProfileCountryIdRequiredError: "需要填写国籍",
    ProfileCityIdRequiredError: "需要填写到达城市",
    ProfileDegreeIdRequiredError: "需要填写学历",
    PasswordMismatchError: "两次输入的密码不一致",
    PasswordMinLengthError: "至少 6 个字符",
  },
  Reset: {
    Title: "重置密码",
    Subtitle: "请输入您注册时填写的邮箱，然后点击“重置”按钮",
    Reset: "重置",
    Login: "登录",
    Success:
      "几分钟后，您将收到发送到 <0>{{email}}</0> 的邮件，其中包含重置密码的说明。",
  },
  CookieNotice: {
    Message:
      "我们使用 Cookie 来改进网站及其用户体验。继续使用本网站即表示您同意使用 Cookie。您始终可以在浏览器设置中禁用 Cookie。",
    Agree: "接受，不再显示",
  },
  MainPage: {
    Title: "主页",
    TitleGreetings: "欢迎来到",
    TitleGreetingsMiddle: "GOVORI",
    TitleGreetingsEnd: "RU!",
    MyCourses: "我的课程",
    CourseContinue: "继续",
    CourseCountStart: "可用",
    CourseCount_one: "{{count}} 门课程",
    CourseCount_other: "{{count}} 门课程",
    AllCourses: "所有课程",
    MyLessons: "我的课时",
    AllLessons: "所有课时",
    EmptyCourses: "没有课程",
    EmptyLessons: "没有课时",
    BuyTeacherLessons: "购买教师课程",
    BuyTeacherLessonsLink: "这里",
    ForeignCardTooltip: "适用于俄罗斯联邦境外发行的银行卡",
    NoActiveLicense: "您没有有效的许可证。",
    GoIntoLesson: "进入课",
    FinishedLessons: "已完成课",
    CanceledLessons: "已取消课",
  },
  CoursesPage: {
    Title: "我的课程",
    TitleGreetings: "欢迎来到",
    MyCourses: "我的课程",
    CourseContinue: "继续",
    EmptyCourses: "没有课程",
    SearchPlaceholder: "按名称搜索",
    LevelPlaceholder: "级别",
    AllLevels: "所有级别",
  },
  Menu: {
    Main: "主页",
    Words: "单词",
    Courses: "我的课程",
    Lessons: "教师授课",
    TeacherCorner: "教师专区",
    AdditionalCourses: "附加课程",
    UsefulLinks: "有用链接",
    Notifications: "通知",
    Video: "视频",
    TeacherGroups: "小组",
    TeacherAttendance: "出勤",
    TeacherClasses: "课程",
    TeacherReports: "报告",
    CreativeTasks: "创意任务",
    Attendance: "出勤",
  },
  Footer: {
    Copyright: "版权",
    About: "关于公司",
    PrivacyPolicy: "隐私政策",
    PrivacyProtect: "隐私保护",
  },
  Module: {
    exercise_one: "练习",
    exercise_few: "练习",
    Completed: "已完成",
    Result: "结果",
    InWork: "进行中",
    Done: "完成",
  },
  SteppedProgress: {
    Completed: "已完成",
  },
  CourseDetails: {
    Title: "课程信息",
    Progress: "进度",
    Completed: "已完成",
    Result: "结果",
    Hours: "课时",
    Lessons: "课数量",
    Units: "单元",
    Unit: "单元",
    Exercises_zero: "练习{{count}}",
    Exercises_one: "练习{{count}}",
    Exercises_other: "练习{{count}}",
    Exercises_many: "练习{{count}}",
  },
  CourseUnitDetails: {
    Vocabulary: "词汇",
    Video: "视频",
    Grammar: "语法",
    Reading: "阅读",
    Writting: "写作",
    Speaking: "口语",
    Test: "测试",
    Unknown: "未知",
    EmptyExercises: "没有练习",
  },
  EntranceTest: {
    ModalTitle: "确定您的知识水平",
    ModalBody: "参加测试以确定您的俄语水平。测试平均需要 40 分钟。",
    Cancel: "取消",
    Take: "开始测试",
  },
  TeacherPage: {
    Title: "教师主页",
    MyLessons: "我的课时",
    MyModules: "我的模块",
  },
  DistributorPage: {
    Title: "分销商主页",
  },
  CoordinatorPage: {
    Title: "协调员主页",
  },
  Button: { Send: "发送", Download: "下载" },
  Distributor: {
    Report: "报告",
    DateFrom: "开始日",
    DateTo: "结束日",
    Status: "状态",
    StatusReady: "准备",
    StatusPlanned: "待处理",
    Actions: "操作",
    FromRequiredError: "需要填写开始日",
    ToRequiredError: "需要填写结束日",
  },
  LessonsTable: {
    GroupName: "小组",
    Status: "状态",
    StartDateTime: "日期和时间",
    Duration: "课程时长",
    Credentials: "网络研讨会：登录用户/密码",
    CredentialsCopied: "已复制！",
    SortAlpabetically: "按A-Z字母顺序",
  },
  LessonStatuses: {
    completed: "已完成",
    planned: "计划",
    earlyCanceledByCustomer: "学员提前取消的课",
    earlyCanceledBySchool: "教师提前取消的课",
    lateCanceledByCustomer: "学员晚点取消的课",
    lateCanceledBySchool: "教师晚点取消的课",
  },
  LessonAttendance: {
    Status: "选择状态",
    Date: "选择日期",
    Time: "选择时间",
    Duration: "时长",
    AH: "学时",
    Students: "学生",
    CheckAll: "全选",
    Comment: "评论",
    Submit: "提交",

    restrictiveBackDateError: "日期不能早于允许范围",
    restrictiveForwardDateError: "日期不能晚于允许范围",
    commentSizeError: "评论不能超过 {{count}} 个词",
    requiredFieldError: "需要填写此字段",
    requiredDateError: "需要填写日期和时间",
    ExcessHoursWarning: "课时数超限制",
    MarkStudents: "请标记参加课程的学生并保存更改。",

    apiError: "您的数据未保存。请联系技术支持 online@dschool.ru",
    early_cancel_by_customer_not_acceptable:
      "无法进行学员提前取消，已有 2 节课被取消，请联系协调员",
    early_cancel_by_school_not_acceptable:
      "无法进行学校提前取消，已有 2 节课被取消，请联系协调员",
  },
  TeacherReportsPage: {
    Title: "报告",
    HeaderTitle: "报告",
    CreateReport: "创建报告",
  },
  TeacherReportTable: {
    Title: "报告标题",
    CreationDate: "创建日期",
    Period: "周期",
    Status: "状态",
    StatusDone: "已完成",
    StatusPending: "待处理",
    Actions: "操作",
    Statistics: "平台统计",
    CourseProgress: "课程进度",
    ActiveTime: "平台活跃时间报告",
    EntranceTest: "入学测试",
    LecenseReport: "使用许可证报告",
    HeaderTitle: "报告",
    CreateReport: "创建报告",
    DeleteReport: "您确定吗？",
    DeleteTooltip: "删除",
    MailTooltip: "发送到邮箱",
    DownloadTooltip: "下载",
    DeleteGroupTooltip: "删除所选",
    MailGroupTooltip: "通过邮件发送所选",
    DownloadGroupTooltip: "下载所选",
  },
  CreateReportForm: {
    Statistics: "平台统计",
    CourseProgress: "课程进度",
    ActiveTime: "平台活跃时间报告",
    Report: "报告",
    Title: "报告标题",
    Type: "报告类型",
    TypeLabel: "类型",
    NameLabel: "标题",
    DateLabel: "日期",
    DateFromLabel: "从",
    DateToLabel: "到",
    Name: "报告名称",
    Period: "周期",
    PeriodFrom: "从",
    PeriodTo: "到",
    Date: "日期",
    FilterListGroup: "小组",
    FilterListStudent: "学生",
    FilterListCompany: "客户公司",
    FilterListTest: "入学测试名称",
    FilterListSelectedStudents: "组过滤器，已选择 {{count}} 名学生",
    FilterListSelectedGroups: "组过滤器，已选择 {{count}} 个小组",
    FilterListCompanies: "组过滤器，已选择 {{count}} 家公司",
    FilterListSelectedTests: "组过滤器，已选择 {{count}} 个入学测试",
    FilterListSelectedPlaceholderStudents: "已选择学生",
    FilterListSelectedPlaceholderGroups: "已选择的小组",
    FilterListSelectedPlaceholderCompanies: "已选择的客户公司",
    FilterListSelectedPlaceholderTests: "选择入学测试",
    GroupsChosen: "已选择的小组",
    ChooseAll: "全选",
    RemoveAll: "移除全部",
    GroupName: "小组",
    GroupDefault: "小组默认",
    Cancel: "取消",
    Create: "创建",
    TitleRequiredError: "需要填写名称",
    FromRequiredError: "需要填写报告周期开始日",
    ToRequiredError: "需要填写报告周期结束日",
    GroupsRequiredError: "请选择一个或几个小组！",
    OrderCreateError: "无法创建新报告",
    FieldRequiredError: "此项必须填写",
    NoItems: "没有小组",
  },
  Gender: {
    Male: "男",
    Female: "女",
  },
  Role: {
    student: "学生",
    teacher: "教师",
    distributor: "分销商",
    coordinator: "协调员",
  },
  EmailNotConfirmed: {
    Title:
      "要进入平台，系统已向您的邮箱 {{email}} 发送了一封邮件。请确认您的地址。如有问题，请联系 online@dschool.ru",
    Back: "<< 返回",
  },
  MyWordsPage: {
    Title: "我的单词",
    EmptyWordList: "没有可学习的单词。请在筛选中选择其他单元",
  },
  WordsFilter: {
    Title: "筛选",
    Clear: "清除",
    EmptyCourses: "没有课程",
    ChooseCourse: "选择课程",
    ChooseUnit: "选择单元",
    EmptyUnits: "没有单元",
  },
  SetupPassword: {
    Title: "设置密码",
    Subtitle: "您需要设置一个新密码，请在下方字段中输入新密码并确认",
  },
  SetupPasswordRedirect: {
    Title: "需要操作",
    Description: "您必须设置密码才能继续使用此服务。",
    Redirect: "设置密码",
  },
  ChangePassword: {
    Password: "密码",
    PasswordRepeat: "重复密码",
    Confirm: "确认",
    PasswordShortError: "密码长度必须大于 6 个字符",
    PasswordMismatch: "两次输入的密码必须一致",
    Success: "密码修改成功",
    Login: "返回登录页面",
  },
  ProfilePage: {
    Title: "我的资料",
  },
  Profile: {
    PersonalData: "个人信息",
    FirstName: "名字",
    LastName: "姓氏",
    BirthDate: "出生日期",
    Citizenship: "国籍",
    Degree: "学历",
    City: "到达城市",
    NewPassword: "新密码",
    ConfirmNewPassword: "确认新密码",
    Password: "密码",
    Save: "保存",
    DataUpdateSuccess: "数据更新成功",
    Settings: "设置",
    ShowPassingResults: "显示通过结果",
  },
  UsefulLinks: {
    Title: "有用链接",
    GroupName: "小组名称：",
    Added: "已添加",
    NoLinks: "没有链接",
  },
  DatePicker: {
    Today: "今天",
    Clear: "清除",
  },
  Promocode: {
    Expired: "该小组的报名已停止。请联系您的经理",
  },
  TeachersAutocompleteFilter: {
    EnterTeacherName: "未找到教师",
    SelectTeacher: "选择教师",
  },
  Loading: {
    Error: "加载错误，请尝试刷新页面",
  },
  MultipleSelect: {
    SelectAll: "全选",
  },
  Attendance: {
    Title: "出勤",
  },
  CreativeTasks: {
    Title: "创意任务",
  },
};

export default zh;
